import { useState, useLayoutEffect } from 'react'

export function useIsMounted() {
  const [isMounted, setIsMounted] = useState(false)

  useLayoutEffect(() => {
    setIsMounted(true)

    // return () => {
    //   setIsMounted(false)
    // }
  }, [])

  return isMounted
}
